import { isEntity } from '@tunasong/schemas'
import type { CoreElement, Entity } from '@tunasong/schemas'
import { entityTemplate } from '../element/templates.js'

export const noteTypes = ['general', 'performance', 'instrument'] as const
export type NoteType = (typeof noteTypes)[number]

export interface Note extends Entity, Omit<CoreElement, 'children'> {
  type: 'note'
  parentId: string
  noteType?: NoteType
}

export const noteTemplate = ({
  parentId,
  noteType = 'general',
  id,
  userId,
}: {
  parentId: string
  noteType?: NoteType
  id?: string
  userId?: string
}): Note => ({
  ...entityTemplate,
  id,
  type: 'note',
  children: [{ type: 'line', children: [{ text: '' }] }],
  parentId,
  noteType,
  userId,
  updatedAt: new Date().toISOString(),
  createdAt: new Date().toISOString(),
})

export function isNote(node?: unknown): node is Note {
  return Boolean(isEntity(node) && node.type === 'note')
}
